import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=3e52ec80&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e52ec80')) {
      api.createRecord('3e52ec80', component.options)
    } else {
      api.reload('3e52ec80', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=3e52ec80&", function () {
      api.rerender('3e52ec80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TnIkpV7BZqlf/JS/comp/ImgFallback.vue"
export default component.exports